import { defineMessages, useIntl } from 'react-intl';

import { unitMapping, type Unit } from '@sorare/core/src/lib/style';

import sub_in from './assets/sub_in.svg';
import sub_in_cyan from './assets/sub_in_cyan.svg';
import sub_out from './assets/sub_out.svg';

const titles = defineMessages({
  sub_in: {
    defaultMessage: 'Sub In',
  },
  sub_out: {
    defaultMessage: 'Sub Out',
  },
});

type Props = {
  type: keyof typeof titles;
  size?: Unit;
  /** `cyan` swaps the green sub-in icon for the cyan So5-substitution variant. */
  variant?: 'default' | 'cyan';
};
export const SubIcon = ({ type, size = 2, variant = 'default' }: Props) => {
  const { formatMessage } = useIntl();

  const image =
    type === 'sub_in' ? (variant === 'cyan' ? sub_in_cyan : sub_in) : sub_out;

  return (
    <img
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      src={image}
      alt=""
      title={formatMessage(titles[type])}
    />
  );
};
